import React from 'react'
import { sendSuccessNotification } from '../../../../../universal/notifications/notifications'
import './style.scss'

const Index = ({details}) => {

    const writeClipboard = value => {
        navigator.clipboard.writeText(value)
        sendSuccessNotification("Verdien ble kopiert.")
    }

    return(
        <div className="dns-configuration-container">
            <p>Vennligst merk deg at endringene i DNS kan ta alt fra 5 minutter til 24 timer før de blir synlige, avhengig av hvilke tjener du bruker.</p>
            <table className="dns-configuration-table">
                <thead>
                <tr>
                    <th>Type</th>
                    <th>Tjener</th>
					<th>Data</th>
                </tr>
                </thead>
                {details && details.dns && details.dns.mail_cname && details.dns.dkim1 && details.dns.dkim2 ?
                    <tbody>
                        <tr>
                            <td><span className="record-type">{details.dns.mail_cname.type}</span></td>
                            <td onClick={() => writeClipboard(details.dns.mail_cname.host)}><span className="record-host">{details.dns.mail_cname.host}</span></td>
                            <td onClick={() => writeClipboard(details.dns.mail_cname.data)}><span className="record-data">{details.dns.mail_cname.data}</span></td>
                        </tr>
                        <tr>
                            <td><span className="record-type">{details.dns.dkim1.type}</span></td>
                            <td onClick={() => writeClipboard(details.dns.dkim1.host)}><span className="record-host">{details.dns.dkim1.host}</span></td>
                            <td onClick={() => writeClipboard(details.dns.dkim1.data)}><span className="record-data">{details.dns.dkim1.data}</span></td>
                        </tr>
                        <tr>
                            <td><span className="record-type">{details.dns.dkim2.type}</span></td>
                            <td onClick={() => writeClipboard(details.dns.dkim2.host)}><span className="record-host">{details.dns.dkim2.host}</span></td>
                            <td onClick={() => writeClipboard(details.dns.dkim2.data)}><span className="record-data">{details.dns.dkim2.data}</span></td>
                        </tr>
                    </tbody>
                :null}
            </table>
            <small>Dersom du ikke vet hvordan man legger til eller endrer DNS-pekere for domenet ditt, så kan du lese mer om det <a href="https://domene.shop/faq?id=15">her</a>.</small>
        </div>
    )
}

export default Index